import { LegalPage, LegalSection } from "./Legal";

const Terms = () => (
  <LegalPage
    eyebrow="Legal"
    title={<>Terms of <span className="text-gradient">Service</span></>}
    description="The terms that govern your use of the Cloudease website and any engagement with our team."
    seoTitle="Terms of Service — Cloudease"
    seoDescription="Read the terms that govern use of the Cloudease website, contact channels, and consulting engagements."
    path="/terms"
    updated="April 2026"
  >
    <LegalSection title="1. Acceptance">
      <p>By accessing cloudease.in or engaging Cloudease for services, you agree to these terms. If you do not agree, please do not use the site or our services.</p>
    </LegalSection>
    <LegalSection title="2. Use of the website">
      <p>You may browse the site for personal or business evaluation. You may not scrape, reverse engineer, disrupt, or attempt to gain unauthorized access to the site or its underlying infrastructure.</p>
    </LegalSection>
    <LegalSection title="3. Consulting engagements">
      <p>Any professional services — CloudOps, DevOps, migration, Kubernetes, AI, or otherwise — are governed by a separately signed Statement of Work or Master Services Agreement. In case of conflict, that agreement controls.</p>
    </LegalSection>
    <LegalSection title="4. Intellectual property">
      <p>All content on cloudease.in — including copy, code snippets, diagrams, and brand marks — is owned by Cloudease or licensed to us. You may share short excerpts with attribution and a link back.</p>
    </LegalSection>
    <LegalSection title="5. Confidentiality">
      <p>Information you share via the contact form or AI concierge is treated as confidential and used only to respond to your inquiry or to deliver requested services.</p>
    </LegalSection>
    <LegalSection title="6. Warranties and liability">
      <p>The website is provided "as is" without warranties of any kind. To the maximum extent permitted by law, Cloudease is not liable for indirect, incidental, or consequential damages arising from use of the site.</p>
    </LegalSection>
    <LegalSection title="7. Third-party links">
      <p>Some pages link to third-party services (Calendly, GitHub, LinkedIn, etc.). We are not responsible for the content or practices of those sites.</p>
    </LegalSection>
    <LegalSection title="8. Changes">
      <p>We may update these terms as our business evolves. Material changes will be reflected by updating the "Last updated" date at the top of this page.</p>
    </LegalSection>
    <LegalSection title="9. Governing law">
      <p>These terms are governed by the laws of India. Disputes will be resolved in the courts of Bengaluru, Karnataka.</p>
    </LegalSection>
    <LegalSection title="10. Contact">
      <p>Questions? <a className="text-primary hover:underline" href="mailto:hello@cloudease.in">hello@cloudease.in</a></p>
    </LegalSection>
  </LegalPage>
);

export default Terms;
